// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const pib: CountryValidator<"RS"> = createValidator(
  "rs.pib",
  152,
);

export default pib;
export const compact = pib.compact;
export const format = pib.format;
export const validate = pib.validate;
export const generate = (): string =>
  pib.generate?.() ??
  (() => {
    throw new Error(
      "Validator rs.pib cannot generate values",
    );
  })();
